export interface Article {
  id: string;
  title: string;
  description: string;
  content: string;
  category: string;
  author: string;
  publishDate: string;
  readTime: string;
  image: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: 'JMComic 新用户入门指南：从注册到开始阅读',
    description: '详细的新手教程，帮助你快速上手 JMComic 漫画平台，享受流畅的漫画阅读体验。',
    content: `<h2>第一步：访问 JMComic 官网</h2>
<p>打开浏览器，在地址栏输入 JMComic 官方最新入口地址，即可进入平台首页。建议将官网加入书签，方便下次快速访问。</p>

<h2>第二步：注册账号</h2>
<p>点击页面右上角的"注册"按钮，填写邮箱地址和设置密码即可完成注册。注册后可以享受书架收藏、阅读历史同步、评论互动等完整功能。</p>

<h2>第三步：浏览漫画资源</h2>
<p>进入首页后，你可以通过以下方式找到想看的漫画：</p>
<ul>
<li><strong>搜索功能：</strong>在顶部搜索框输入漫画名称或作者名</li>
<li><strong>分类浏览：</strong>点击导航栏的"分类"，按题材筛选漫画</li>
<li><strong>排行榜：</strong>查看人气排行和评分排行，发现热门作品</li>
<li><strong>推荐位：</strong>首页编辑精选推荐优质漫画</li>
</ul>

<h2>第四步：开始阅读</h2>
<p>点击任意漫画封面进入详情页，可以选择"从头开始"或"继续阅读"。JMComic 支持多种阅读模式，包括滚动阅读和翻页阅读，可根据个人习惯自由切换。</p>

<h2>第五步：使用书架功能</h2>
<p>阅读过程中点击"收藏"按钮，漫画会自动添加到你的书架。已收藏的漫画更新时会收到通知提醒。</p>

<h2>小贴士</h2>
<p>在移动端访问 JMComic 也能获得出色的阅读体验，网站针对手机和平板进行了全面适配优化。</p>`,
    category: 'tutorial',
    author: 'JMComic 编辑团队',
    publishDate: '2026-08-10',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20digital%20reading%20scene%20with%20a%20tablet%20displaying%20colorful%20manga%20pages%2C%20cozy%20reading%20environment%20with%20warm%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20comfortable%20atmosphere%2C%20professional%20productivity%20photography&width=800&height=450&seq=article-guide-01&orientation=landscape',
    tags: ['新手教程', '入门指南', '使用教程'],
  },
  {
    id: 'article-2',
    title: 'JMComic 五大隐藏功能，99% 的用户都不知道',
    description: '揭秘 JMComic 中那些不为人知但超级实用的隐藏功能，让你的漫画阅读体验更上一层楼。',
    content: `<h2>功能一：智能阅读模式</h2>
<p>在阅读设置中开启"智能阅读模式"，系统会自动识别漫画的分镜布局，智能调整显示区域，让你无需手动缩放就能看清每一个细节。这对于细节丰富的战斗场景和背景画面特别有用。</p>

<h2>功能二：离线缓存</h2>
<p>在移动端使用 JMComic 时，你可以将漫画章节提前缓存到本地。即使在没有网络的情况下也能畅快阅读。缓存管理功能还能自动清理已读章节，节省手机存储空间。</p>

<h2>功能三：自定义阅读主题</h2>
<p>除了默认的浅色和深色主题外，JMComic 还支持自定义背景色、文字大小和间距。进入"阅读设置-主题定制"即可自由搭配，打造专属的阅读界面。</p>

<h2>功能四：跨设备同步</h2>
<p>只要登录同一个账号，你的阅读进度、书架收藏和阅读偏好都会自动在多设备间同步。在手机上看到一半，换到电脑上继续看，进度无缝衔接。</p>

<h2>功能五：社区互动</h2>
<p>每一部漫画下方都有专属的讨论区，你可以和其他读者交流剧情、发表评论、参与话题讨论。热门作品还会定期举办读者投票和活动。</p>`,
    category: 'tips',
    author: 'JMComic 编辑团队',
    publishDate: '2026-08-05',
    readTime: '4分钟',
    image: 'https://readdy.ai/api/search-image?query=A%20creative%20digital%20illustration%20showing%20hidden%20features%20and%20easter%20eggs%20in%20a%20comic%20reading%20app%20interface%2C%20modern%20UI%20design%2C%20colorful%20and%20playful%20style%2C%20clean%20minimalist%20aesthetic%2C%20technology%20concept%20art&width=800&height=450&seq=article-tips-02&orientation=landscape',
    tags: ['隐藏功能', '使用技巧', '高级玩法'],
  },
  {
    id: 'article-3',
    title: '2026 年最值得追的 10 部漫画推荐',
    description: '编辑团队精选本年度最值得一看的热门漫画，涵盖热血、恋爱、奇幻等多种题材。',
    content: `<h2>热血少年类</h2>
<p><strong>《星界战记》</strong>：被读者称为"年度最强热血漫"，宏大的世界观、精彩的人物塑造，每一话都让人热血沸腾。</p>
<p><strong>《剑道少女》</strong>：以剑道为主题的青春成长漫，画风精美，剧情扎实，已完结可一次追完。</p>

<h2>恋爱校园类</h2>
<p><strong>《樱花下的约定》</strong>：纯爱标杆之作，温暖细腻的情感描写让无数读者落泪。已完结，评分高达 4.9。</p>
<p><strong>《夏日蝉鸣时》</strong>：正在连载中的夏日恋爱故事，画风清新唯美，青春感十足。</p>

<h2>奇幻冒险类</h2>
<p><strong>《魔法学院录》</strong>：人气突破百万的现象级作品，魔法学院题材的巅峰之作，剧情反转不断。</p>
<p><strong>《异世界餐厅》</strong>：独特的美食+异世界组合，轻松有趣又让人食欲大增。</p>

<h2>搞笑日常类</h2>
<p><strong>《今天也超好笑》</strong>：长期霸占人气榜首的搞笑漫画，每话独立成篇，随时可以笑出声。</p>

<h2>悬疑烧脑类</h2>
<p><strong>《暗夜行者》</strong>：悬疑推理漫画中的黑马，剧情紧凑环环相扣，让人欲罢不能。</p>

<h2>治愈日常类</h2>
<p><strong>《猫咪咖啡馆》</strong>：猫奴必看的治愈系漫画，暖心又放松。</p>
<p><strong>《深夜食堂故事》</strong>：深夜美食与人生故事的交织，温暖人心。</p>`,
    category: 'recommend',
    author: 'JMComic 编辑团队',
    publishDate: '2026-07-28',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=A%20colorful%20collage%20style%20illustration%20of%20top%20manga%20covers%20arranged%20artistically%2C%20various%20manga%20genres%20represented%2C%20vibrant%20colors%2C%20award%20ribbon%20design%20element%2C%20clean%20and%20modern%20composition%2C%20editorial%20design%20aesthetic&width=800&height=450&seq=article-recommend-03&orientation=landscape',
    tags: ['漫画推荐', '热门排行', '必追漫画'],
  },
  {
    id: 'article-4',
    title: 'JMComic 常见问题解答（FAQ）',
    description: '汇总用户最常问的问题，包括访问方法、账号安全、阅读设置等。',
    content: `<h2>访问相关</h2>
<h3>Q：JMComic 的最新入口地址是什么？</h3>
<p>A：请收藏本官方网站，我们会在这里及时更新最新入口地址。为确保访问稳定，建议同时关注官方社交媒体账号获取最新动态。</p>

<h3>Q：为什么有时候打不开 JMComic？</h3>
<p>A：可能是网络波动或浏览器缓存问题。请尝试以下方法：1）清除浏览器缓存和 Cookie；2）切换网络环境；3）使用最新版 Chrome 或 Edge 浏览器访问。</p>

<h2>账号相关</h2>
<h3>Q：忘记密码怎么办？</h3>
<p>A：在登录页面点击"忘记密码"，输入注册邮箱即可收到密码重置链接。</p>

<h3>Q：一个账号可以在多个设备上使用吗？</h3>
<p>A：可以，JMComic 支持多设备同时登录，阅读进度和书架数据会自动同步。</p>

<h2>阅读相关</h2>
<h3>Q：漫画更新频率是怎样的？</h3>
<p>A：不同漫画的更新频率不同，热门连载漫画通常每周更新 1-2 话。已完结漫画可以一次性阅读全部章节。</p>

<h3>Q：阅读时图片加载慢怎么办？</h3>
<p>A：可以在阅读设置中调整图片质量，选择"流畅模式"可以加快加载速度。同时建议在网络良好的环境下阅读。</p>`,
    category: 'faq',
    author: 'JMComic 编辑团队',
    publishDate: '2026-08-01',
    readTime: '3分钟',
    image: 'https://readdy.ai/api/search-image?query=A%20minimalist%20illustration%20of%20frequently%20asked%20questions%20concept%2C%20speech%20bubbles%20with%20question%20marks%2C%20clean%20and%20modern%20design%2C%20soft%20warm%20colors%2C%20help%20and%20support%20theme%2C%20professional%20corporate%20illustration%20style&width=800&height=450&seq=article-faq-04&orientation=landscape',
    tags: ['FAQ', '常见问题', '帮助中心'],
  },
  {
    id: 'article-5',
    title: 'JMComic 移动端使用全攻略',
    description: '全面介绍 JMComic 在手机和平板上的使用方法和优化技巧，让你随时随地畅享漫画。',
    content: `<h2>移动端访问方式</h2>
<p>JMComic 采用了响应式网页设计，无需下载任何 APP，直接在手机浏览器中输入官网地址即可访问。网站会自动适配屏幕尺寸，提供最佳显示效果。</p>

<h2>添加到主屏幕</h2>
<p><strong>iOS 用户：</strong>在 Safari 浏览器中打开 JMComic，点击底部分享按钮，选择"添加到主屏幕"，即可像使用 APP 一样快速启动。</p>
<p><strong>Android 用户：</strong>在 Chrome 浏览器中打开 JMComic，点击菜单中的"添加到主屏幕"，就会在主屏生成快捷方式图标。</p>

<h2>移动端专属功能</h2>
<ul>
<li><strong>手势翻页：</strong>左右滑动即可翻页，单手操作超方便</li>
<li><strong>双击放大：</strong>双击画面可以放大查看细节</li>
<li><strong>竖屏滚动：</strong>支持竖屏连续滚动阅读模式</li>
<li><strong>音量键翻页：</strong>在设置中开启后可用音量键翻页</li>
</ul>

<h2>省流量技巧</h2>
<p>在移动网络下阅读漫画时，建议开启"省流量模式"。该模式会适度压缩图片，在保证阅读体验的同时大幅减少流量消耗。</p>`,
    category: 'tutorial',
    author: 'JMComic 编辑团队',
    publishDate: '2026-07-20',
    readTime: '4分钟',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20colorful%20manga%20reading%20interface%20on%20screen%2C%20held%20in%20hand%20against%20clean%20background%2C%20mobile%20app%20UI%20design%2C%20bright%20and%20vibrant%20colors%2C%20professional%20product%20photography&width=800&height=450&seq=article-mobile-05&orientation=landscape',
    tags: ['移动端', '手机阅读', '使用教程'],
  },
  {
    id: 'article-6',
    title: '如何安全稳定地访问 JMComic',
    description: '分享几个确保稳定访问 JMComic 的实用方法，让你不再错过任何漫画更新。',
    content: `<h2>方法一：收藏官方网站</h2>
<p>最重要的方法是收藏 JMComic 的官方网站。官方网站会始终显示最新可用的访问入口地址，是最可靠的信息来源。</p>

<h2>方法二：关注官方社交媒体</h2>
<p>JMComic 在多个社交媒体平台设有官方账号，会及时发布入口更新通知和平台动态。建议关注获取第一手信息。</p>

<h2>方法三：使用稳定的网络环境</h2>
<p>建议使用稳定的家庭宽带或移动网络访问 JMComic。公共 Wi-Fi 可能存在不稳定的情况，影响访问体验。</p>

<h2>方法四：保持浏览器更新</h2>
<p>使用最新版本的 Chrome、Edge 或 Safari 浏览器访问，可以获得最佳兼容性和加载速度。旧版浏览器可能无法正常显示部分功能。</p>

<h2>方法五：加入官方社区</h2>
<p>JMComic 官方社区是读者交流的重要平台。在社区中，你可以获取最新动态、参与讨论，还能向管理员反馈问题。</p>`,
    category: 'tips',
    author: 'JMComic 编辑团队',
    publishDate: '2026-07-15',
    readTime: '3分钟',
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20illustration%20of%20secure%20internet%20access%20with%20a%20shield%20and%20lock%20icon%2C%20digital%20security%20theme%2C%20clean%20modern%20design%2C%20blue%20and%20green%20gradient%20colors%2C%20professional%20technology%20illustration%20style&width=800&height=450&seq=article-access-06&orientation=landscape',
    tags: ['访问方法', '安全上网', '实用技巧'],
  },
];